"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDatePaginatorStyle = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var react_2 = require("@transifex/react");
var moment_1 = __importDefault(require("moment"));
var SelectYearSimple_1 = require("./SelectYearSimple");
var SelectMonthSimple_1 = require("./SelectMonthSimple");
var BtnPrevMonth = function (props) { return (react_1.default.createElement(antd_1.Button, __assign({ type: "text" }, props),
    react_1.default.createElement(antd_1.Space, { size: 4 },
        react_1.default.createElement(icons_1.LeftOutlined, null),
        react_1.default.createElement(react_2.UT, { _str: "Last month", _inline: true })))); };
var BtnNextMonth = function (props) { return (react_1.default.createElement(antd_1.Button, __assign({ type: "text" }, props),
    react_1.default.createElement(antd_1.Space, { size: 4 },
        react_1.default.createElement(react_2.UT, { _str: "Next month", _inline: true }),
        react_1.default.createElement(icons_1.RightOutlined, null)))); };
/*
DEV:
- Todo:
1. Add date picker option.
2. Add prev/next buttons for years.
@saad will disucss with @xin later.
*/
var SelectDatePaginatorStyle = function (_a) {
    var validRange = _a.validRange, value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement(antd_1.Row, { gutter: 8 }, [
        react_1.default.createElement(BtnPrevMonth, { onClick: function () { return onChange(moment_1.default(value).subtract(1, "month")); } }),
        react_1.default.createElement(SelectYearSimple_1.SelectYearSimple, { value: moment_1.default(value).year(), validRange: validRange === null || validRange === void 0 ? void 0 : validRange.map(function (range) { return moment_1.default(range).year(); }), onChange: function (year) { return onChange(moment_1.default(value).set("year", year)); } }),
        react_1.default.createElement(SelectMonthSimple_1.SelectMonthSimple, { value: moment_1.default(value).month(), onChange: function (month) {
                return onChange(moment_1.default(value).set("month", month));
            } }),
        react_1.default.createElement(BtnNextMonth, { onClick: function () { return onChange(moment_1.default(value).add(1, "month")); } }),
    ].map(function (node) { return (react_1.default.createElement(antd_1.Col, null, node)); })));
};
exports.SelectDatePaginatorStyle = SelectDatePaginatorStyle;
exports.default = exports.SelectDatePaginatorStyle;
